import CartIcon from '@/fo/icons/base/icons/bag-stroke.svg';
import CheckIcon from '@/fo/icons/base/icons/check.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './ButtonBuy.styles';

type NativeElement = React.HTMLAttributes<HTMLButtonElement>;

export interface ButtonBuyProps {
  className?: string;
  isInCart: boolean;
  onClick?: NativeElement['onClick'];
  disabled?: boolean;
  loading?: boolean;
}

export function ButtonBuy({
  className,
  isInCart,
  onClick,
  disabled,
  loading
}: ButtonBuyProps) {
  const slots = styles({ isInCart });
  return (
    <UiKitButtonBase
      className={slots.base({ className })}
      rounded="full"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      color="secondary"
    >
      <CartIcon className={slots.cartIcon()} />
      {isInCart && <CheckIcon className={slots.plusIcon()} />}
    </UiKitButtonBase>
  );
}
